export default "__VITE_ASSET__D50YTK1Z__"